var map = {
	"./featured-banner.de-CH.json": 1165,
	"./featured-banner.de-DE.json": 1166,
	"./featured-banner.en-CA.json": 1167,
	"./featured-banner.en-GB.json": 1168,
	"./featured-banner.en-IN.json": 1169,
	"./featured-banner.en-ME.json": 1170,
	"./featured-banner.en-US.json": 1171,
	"./featured-banner.es-EM.json": 1172,
	"./featured-banner.es-ES.json": 1173,
	"./featured-banner.fr-BE.json": 1174,
	"./featured-banner.fr-CA.json": 1175,
	"./featured-banner.fr-CH.json": 1176,
	"./featured-banner.nl-BE.json": 1177,
	"./featured-banner.nl-NL.json": 1178,
	"./featured-banner.pl-PL.json": 1179,
	"./featured-banner.pt-BR.json": 1180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1164;